export const removeArrayDuplication = <T>(data: T[]): T[] => [...new Set(data)];
